import React, { useState } from 'react';
import { Table as AntTable, Button, Modal, Typography, Image, Row, Col } from 'antd';
import { Descriptions, Divider } from 'antd';
import { SearchOutlined, EditOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import dayjs from 'dayjs';
import DetailsModal from './DetailsModal';
import EditModal from './editModal';
import MapinputModal from './MapinputModal';
import { useFetchMapInputAudit } from '../hooks/useFetch';
const { Title, Text } = Typography;
const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};

const Table = ({ data = [], loading = false, refetch }) => {
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [mapModalVisible, setMapModalVisible] = useState(false);
  const { mutateAsync: mapInputAudit } = useFetchMapInputAudit();
  const renderCustomFields = (customFields) => {
    if (!customFields) return null;

    // รองรับทั้ง array format (ใหม่) และ object format (เก่า)
    let fieldsArray = [];

    if (Array.isArray(customFields)) {
      // Format ใหม่: array ของ objects [{number, title, value}, ...]
      fieldsArray = customFields;
    } else if (typeof customFields === 'object') {
      // Format เก่า: object {title: value, ...}
      fieldsArray = Object.entries(customFields).map(([title, value]) => ({
        number: 0,
        title,
        value
      }));
    } else {
      return null;
    }

    // เรียงลำดับ: NOTE. ขึ้นก่อน แล้วเรียงตาม number
    fieldsArray = [...fieldsArray].sort((a, b) => {
      const aIsNote = a.title === "NOTE." || a.title === "NOTE";
      const bIsNote = b.title === "NOTE." || b.title === "NOTE";

      // NOTE. ขึ้นก่อน
      if (aIsNote && !bIsNote) return -1;
      if (!aIsNote && bIsNote) return 1;
      if (aIsNote && bIsNote) return 0;

      // ถ้าไม่ใช่ NOTE. ให้เรียงตาม number
      return (a.number || 0) - (b.number || 0);
    });

    return fieldsArray.map((field) => {
      const { title, value } = field;

      // ตรวจสอบว่า value เป็น array ของ image URLs หรือไม่
      if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string' && value[0].startsWith('http')) {
        // Handle image URLs in custom fields
        return (
          <div key={title} style={{ marginBottom: 16 }}>
            <Text strong>{title}: </Text>
            <div style={{ marginTop: 8 }}>
              <Row gutter={[8, 8]}>
                {value.map((url, index) => (
                  <Col key={index} xs={12} sm={8} md={6}>
                    <Image
                      width="200%"
                      src={url}
                      alt={`${title} ${index + 1}`}
                      style={{ borderRadius: 4 }}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        );
      } else {
        // Handle regular text fields
        return (
          <Descriptions.Item key={title} label={title} span={3}>
            {Array.isArray(value) ? value.join(', ') : String(value)}
          </Descriptions.Item>
        );
      }
    });
  };

  const handleMapEdit = async (record) => {
    try {
      await mapInputAudit(record);
      setMapModalVisible(false);
      refetch();
    } catch (error) {
      console.error('Error mapping input audit:', error);
    }
  };

  const handleEdit = (record) => {
    setSelectedRecord(record);
    setEditModalVisible(true);
  };


  const handleViewDetails = (record) => {
    setSelectedRecord(record);
    setDetailsModalVisible(true);
  };

  const handleCloseDetails = () => {
    setDetailsModalVisible(false);
    setSelectedRecord(null);
  };

  const handleMapInput = (record) => {
    setSelectedRecord(record);
    setMapModalVisible(true);
  };

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'number',
      key: 'number',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'User ID',
      dataIndex: 'auditUserId',
      key: 'auditUserId',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text, record) => (
      //   <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
      //     {record.case3Display || '-'}
      //   </span>
      // ),
    },
    {
      title: 'Amount',
      dataIndex: 'auditAmount',
      key: 'auditAmount',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || 0}</span>,
    },
    {
      title: 'วันที่-เวลา',
      dataIndex: 'startEndDate',
      key: 'startEndDate',
      align: 'center',
      width: 180,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text, record) => <span style={{ color: '#333' }}>{dayjs(record.auditDate).format('DD/MM/YYYY HH:mm') || '-'}</span>,
    },
    {
      title: 'Admin Name',
      dataIndex: 'finishByName',
      key: 'finishByName',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'หมายเหตุ',
      // dataIndex: 'remarkCase',
      // key: 'remarkCase',
      align: 'center',
      width: 250,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (record) => {
        const text =
          [record.case1Display, record.case2Display, record.case3Display]
            .filter(Boolean)
            .join(" ");
        return (
          <span style={{ color: '#333', fontWeight: 500 }}>
            {text.length > 0 ? text : '-'}
          </span>
        );
      },
    },
    {
      // matchStatus = ผลจับคู่กับเคสเท่านั้น (Match / Not Match)
      // การตรวจซ้ำย้ายไปคอลัมน์ dupStatus แล้ว เดิมสองเรื่องนี้ปนกันอยู่ช่องเดียว
      // ทำให้แถวที่ถูกตีว่าซ้ำมองไม่ออกเลยว่าจับคู่เคสได้หรือเปล่า
      title: 'Status',
      dataIndex: 'matchStatus',
      key: 'matchStatus',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => {
        return (
          <span style={{
            color: text === 'Match' ? '#4caf50' : text === 'Not Match' ? '#f44336' : '#333',
            fontWeight: 500
          }}>
            {text}
          </span>
        );
      },
    },
    {
      title: 'ซ้ำ',
      dataIndex: 'dupStatus',
      key: 'dupStatus',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => {
        if (!text || text === 'None') return <span style={{ color: '#bfbfbf' }}>-</span>;
        return (
          <span style={{
            color: text === 'Duplicate' ? '#d48806' : '#faad14',
            fontWeight: 500
          }}>
            {text}
          </span>
        );
      },
    },
    {
      title: 'รายละเอียด',
      key: 'details',
      align: 'center',
      width: 120,
      fixed: 'right',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            type="text"
            icon={<SearchOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
            onClick={() => handleViewDetails(record)}
            style={{ borderRadius: 6 }}
          />
          {record.auditStatus === 'Fail' && (
            <Button
              type="text"
              icon={<EditOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
              onClick={() => handleEdit(record)}
              style={{ borderRadius: 6 }}
            />
          )}
          {/* เกณฑ์คือ "ยังไม่มีเคสผูกอยู่" ตรง ๆ ไม่ใช่ไล่ชื่อสถานะ
              เดิมผูกกับ matchStatus === 'Duplicate' ซึ่งพอย้ายไป dupStatus ปุ่มจะหายไปทั้งแถว */}
          {!record.inputId && (
            <Button
              type="text"
              title="จับคู่กับเคส Input"
              icon={<UnorderedListOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
              onClick={() => handleMapInput(record)}
              style={{ borderRadius: 6 }}
            />
          )}
        </div>
      ),
    },
    {
      title: 'Audit Status',
      dataIndex: 'auditStatus',
      key: 'auditStatus',
      align: 'center',
      width: 120,
      fixed: 'right',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => {
        return (
          <span style={{ color: text === 'Pass' ? 'green' : text === 'Fail' ? 'red' : 'blue', fontWeight: 500 }}>{text}</span>
        );
      },
    },
    {
      title: 'Fail Remark',
      dataIndex: 'failRemark',
      key: 'failRemark',
      align: 'center',
      fixed: 'right',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
  ];

  return (
    <div style={{ padding: '20px', background: '#fff' }}>
      <div className='overflow-x-auto'>
        <AntTable
          loading={loading}
          dataSource={genNumberTable(data)}
          columns={columns}
          //pagination={{ pageSize: 10 }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          bordered
          pagination={{
            position: ['topRight'],
            //pageSize: 10,
            pageSizeOptions: [10, 20, 50, 100],
            showSizeChanger: true,
            showQuickJumper: false,
            total: data.length,   // 👈 สำคัญ
          }}
        //showTotal={(total, range) => `รวม ${total} รายการ`}
        // onChange={(page, pageSize) => {
        //   console.log(page, pageSize);
        // }}
        />
      </div>
      <DetailsModal
        visible={detailsModalVisible}
        onClose={() => {
          setDetailsModalVisible(false);
          setSelectedRecord(null);
        }}
        record={selectedRecord}
        refetch={refetch}
        setDetailsModalVisible={setDetailsModalVisible}
      />

      <EditModal
        visible={editModalVisible}
        onClose={() => {
          setEditModalVisible(false);
          setSelectedRecord(null);
        }}
        record={selectedRecord}
        refetch={refetch}
      />
      <MapinputModal
        visible={mapModalVisible}
        onClose={() => {
          setMapModalVisible(false);
          setSelectedRecord(null);
        }}
        record={selectedRecord}
        refetch={refetch}
        handleMapEdit={handleMapEdit}
      />
      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
      `}</style>
    </div>
  );
};

export default Table;

